
import { Component, Mixins } from 'vue-property-decorator'
import IconsMixin from '@/mixins/IconsMixin.vue'
import AuthMixin from '@/mixins/AuthMixin.vue'
import capitalCase from '@/functions/capitalCase'
import { Company, CompanyCollection, User, UserMapper, UserRoleEnum } from '@/firestore'
import AddExistingUserModal from '@/components/User/AddExistingUserModal.vue'
import axios from 'axios'

@Component({
  components: {AddExistingUserModal}
})
export default class UserList extends Mixins(IconsMixin, AuthMixin) {
  public users: User[] = []
  public company: Company = {} as Company
  public sharedUsers = null
  public roles = this.generateItems(UserRoleEnum)
  public loadingUsers = false

  // modal props
  public showAddExistingUserModal = false

  public headers = [
    {text: 'Name', value: 'name'},
    {text: 'Email', value: 'email'},
    {text: 'Role', value: 'role'},
    {text: 'Status', value: 'status'}
  ]

  public async mounted() {
    this.loadingUsers = true

    const companyCollection = new CompanyCollection((await this.$firebase).firestore())
    const company = await companyCollection.getCompany(this.userCompany.id)
    if (company) {
      this.company = company
    }

    await this.loadUsers()

    this.loadingUsers = false
  }

  public async loadUsers() {
    this.loadingUsers = true
    const userMapper = new UserMapper()
    this.users = (await axios.get('/api/users', {
      params: {companyId: this.userCompany.id}
    })).data.map(userMapper.map)
    this.loadingUsers = false
  }

  public async addUser() {
    return await this.$router.push({name: 'user-edit', params: {id: 'create'}})
  }

  public async editUser(user: User) {
    return await this.$router.push({name: 'user-edit', params: {id: user.id}})
  }

  private generateItems(enumSet: { [key: string]: string }) {
    return Object.values(enumSet).map((v) => (
        {
          text: capitalCase(v),
          value: v
        }
    ))
  }
}
